import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  NavItem,
  NavLink,
  Nav
} from "reactstrap";
import CouponCard from "./dealerSchemeCoupon";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getPromotionList } from "helpers/UAM/promotion.helper";
import { schemesData } from "../../common/data/promotion"

const SchemesForDealer = props => {
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const [title, setTitle] = useState("All Promotions")
  const [schemList, setSchemeList] = useState([]);

  useEffect(() => {
    getPromocodeList()
  }, []);

  const getPromocodeList = () => {
    getPromotionList({filterType:true,dealer:true})
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setSchemeList(responseFromAPI.data.data)
        } else {
          setSchemeList([])
        }
      })
      .catch(error => { })
  }

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
    if (tab == "1") {
      setTitle("All Schemes")
      getPromocodeList()
    } else {
      getPromocodeList()
      setTitle("Availed Schemes")
      const data = schemesData.filter((ele) => {
        if (!ele.availed) {
          return ele
        }
      })
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Promotions" breadcrumbItem={title} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row>
                    {schemList.map((text, index) => (
                      <Col key={index} xs="12" md="4" className="mb-4">
                        <CouponCard couponText={text} />
                      </Col>
                    ))}
                    {schemList.length == 0 && (
                      <div className="text-center">
                        <p className="font-size-16">
                          No Promotions Found
                        </p>
                      </div>
                     )}
                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

SchemesForDealer.propTypes = {
  customers: PropTypes.array,
  onGetCustomers: PropTypes.func,
  onAddNewCustomer: PropTypes.func,
  onDeleteCustomer: PropTypes.func,
  onUpdateCustomer: PropTypes.func,
};

export default SchemesForDealer;
